import * as yup from "yup";

export const LoginSchema = yup.object().shape({
	username: yup
		.string()
		.email("Username must be a valid email")
		.required("Username is required"),
	password: yup.string().required("Password is required")
});
